/**
 * echarts 主题色读取工具
 * ---------------------------------------------------------------------------
 * echarts 的 color 属性由 canvas 绘制，不接受 CSS 变量，必须由 JS 取到实际色值再传入。
 * 用法：把图表配置里的 color: '#409eff' 换成 color: lcsjChartColor.primary
 * 模板字符串（tooltip/label）里需用插值：color: ${lcsjChartColor.primary}
 * 主题切换时通过 window 的 'lcsj-theme-changed' 事件自动清缓存。
 */
const cache = {};

/** 读取 CSS 变量并缓存（主题切换后需调用 lcsjChartColor.clearCache()） */
function readVar(name, fallback) {
	if (cache[name] !== undefined) return cache[name];
	let val = fallback;
	try {
		if (typeof window !== "undefined" && window.getComputedStyle) {
			val = window.getComputedStyle(document.documentElement).getPropertyValue(name);
			val = (val || "").trim() || fallback;
		}
	} catch (e) {
		val = fallback;
	}
	cache[name] = val;
	return val;
}

export const lcsjChartColor = {
	get primary() {
		return readVar("--app-primary", "#2E5AA8");
	},
	get primaryHover() {
		return readVar("--app-primary-hover", "#3C6DC0");
	},
	get primarySoft() {
		return readVar("--app-primary-soft", "#EDF2FB");
	},
	get success() {
		return readVar("--app-success", "#67C23A");
	},
	get warning() {
		return readVar("--app-warning", "#E6A23C");
	},
	get danger() {
		return readVar("--app-danger", "#F56C6C");
	},
	get info() {
		return readVar("--app-info", "#73C0DE");
	},
	get text() {
		return readVar("--app-text", "#303133");
	},
	get textSecondary() {
		return readVar("--app-text-secondary", "#5A6472");
	},
	get border() {
		return readVar("--app-border", "#E4E7ED");
	},
	/** 主色渐变（图表柱/线常用） */
	gradient(from, to) {
		return { from: from || lcsjChartColor.primarySoft, to: to || lcsjChartColor.primary };
	},
	clearCache() {
		Object.keys(cache).forEach((k) => delete cache[k]);
	}
};

// 主题切换（明暗/ 换主色）时自动清缓存。
// theme.js 用 window.dispatchEvent 通知，避免它与本模块产生循环依赖。
if (typeof window !== "undefined" && window.addEventListener) {
	window.addEventListener("lcsj-theme-changed", () => lcsjChartColor.clearCache());
}

export default lcsjChartColor;